<h2 mat-dialog-title>Gerar Cobrança</h2>

<mat-dialog-content>
  @if (isLoading) {
  <div class="estado-loading">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Gerando cobrança de "{{ data.descricao }}"…</p>
    <p class="aviso-pix"><small>Você pode fechar — a cobrança continua sendo gerada e enviada.</small></p>
  </div>
  }

  @if (!isLoading && resultado?.isError) {
  <div class="estado-erro">
    <mat-icon>error_outline</mat-icon>
    <p>{{ resultado?.errorDescription }}</p>
  </div>
  }

  @if (!isLoading && !resultado?.isError) {
  <div class="estado-ok">
    <mat-icon class="icone-ok">check_circle</mat-icon>
    <p>Cobrança enviada para <strong>{{ resultado?.emailEnviado }}</strong>.</p>

    @if (isBoleto) {
    @if (resultado?.jaPago) {
    <p class="aviso">Atenção: este boleto já consta como <strong>pago</strong>.</p>
    }

    @if (resultado?.linhaDigitavel) {
    <div class="linha-digitavel">{{ resultado?.linhaDigitavel }}</div>
    <button mat-stroked-button class="btn-secondary" (click)="copiarLinhaDigitavel()">
      <mat-icon>{{ copiado ? 'check' : 'content_copy' }}</mat-icon>
      {{ copiado ? 'Copiado!' : 'Copiar' }}
    </button>
    }

    @if (resultado?.urlBoletoPdf) {
    <a mat-flat-button class="btn-primary" [href]="resultado?.urlBoletoPdf" target="_blank" rel="noopener">
      <mat-icon>picture_as_pdf</mat-icon>
      Baixar boleto (PDF)
    </a>
    }
    } @else {
    <p class="aviso-pix">O cliente conclui o pagamento pelo link enviado no e-mail.</p>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button class="btn-primary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>